
import { Home, BookOpen, Library, FileText, GraduationCap } from "lucide-react";
import { Link } from "react-router-dom";
import { UNPROTECTED_ROUTES, PROTECTED_ROUTES } from "../../routes/routes";


function FooterTabs() {
  return (
    <div className="fixed bottom-0 rounded-t-2xl shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.4)] p-4 bg-white w-full block xl:hidden">
      <ul className="flex space-x-6 items-center justify-around">
        <li className=" text-gray-700 hover:text-blue-600 cursor-pointer">
          <Link to={UNPROTECTED_ROUTES?.home} className="flex flex-col items-center"><Home size={21} />
            <span className="hover:text-[#1ECBDB] !ml-0">Home</span></Link>
        </li>
        <li className="flex flex-col items-center space-x-2 text-gray-700 hover:text-blue-600 cursor-pointer">
          <Link to={UNPROTECTED_ROUTES?.testSeriesAll} className="flex flex-col items-center"><FileText size={21} />
            <span className="hover:text-[#1ECBDB] !ml-0" >Test</span></Link>
        </li>
        <li className="flex flex-col items-center space-x-2 text-gray-700 hover:text-blue-600 cursor-pointer">
          <Link to={UNPROTECTED_ROUTES?.coursesAll} className="flex flex-col items-center"><GraduationCap size={21} />
            <span className="hover:text-[#1ECBDB] !ml-0 ">Course</span></Link>
        </li>
        <li className="flex flex-col items-center space-x-2 text-gray-700 hover:text-blue-600 cursor-pointer">
          <Link to={UNPROTECTED_ROUTES?.booksAll} className="flex flex-col items-center"><BookOpen size={21} />
            <span className="hover:text-[#1ECBDB] !ml-0">Book</span></Link>
        </li>
        <li className="flex flex-col items-center space-x-2 text-gray-700 hover:text-blue-600 cursor-pointer">
          <Link to={UNPROTECTED_ROUTES?.freeLibrary} className="flex flex-col items-center"><Library size={21} />
            <span className="hover:text-[#1ECBDB] !ml-0">Library</span></Link>
        </li>
      </ul>
    </div>
  )
};

export default FooterTabs;